import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFlipVertically20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconFlipVertically20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m15.488 14.346-1.403-9a1 1 0 0 0-.988-.846h-.922V3h.922a2.5 2.5 0 0 1 2.47 2.115l1.403 9A2.5 2.5 0 0 1 14.5 17h-2.325v-1.5H14.5a1 1 0 0 0 .989-1.154M7.805 3v1.5h-.902a1 1 0 0 0-.988.846l-1.403 9A1 1 0 0 0 5.5 15.5h2.305V17H5.5a2.5 2.5 0 0 1-2.47-2.885l1.403-9A2.5 2.5 0 0 1 6.903 3zm2.935-1.25a.75.75 0 0 0-1.5 0v16.501a.75.75 0 0 0 1.5 0z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconFlipVertically20);
